var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgPattern1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 90,
    viewBox: "0 0 84 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7485 88.2652C64.7485 87.2808 65.1377 86.4143 65.4412 85.486C65.82 84.3273 66.2335 83.2289 66.4866 82.0357C66.555 81.7132 66.5296 81.3744 66.5296 81.0462C66.5296 80.6509 66.2751 80.6256 65.9101 80.5213",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8223 67.8214C76.7243 67.8214 77.6263 67.8214 78.5283 67.8214C79.2909 67.8214 80.13 67.9685 80.7827 67.5116C81.1196 67.2757 81.3329 66.9958 81.6474 66.7372C81.9193 66.5136 82.2115 66.3299 82.4046 66.0403",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9036 67.9762C64.8702 67.8983 61.7577 69.8164 61.3113 70.0585C60.4958 70.5008 59.5979 70.8698 58.6913 71.0738C58.0395 71.2204 57.2603 71.2617 56.7209 70.8243C56.279 70.466 55.7738 70.0791 55.4561 69.6025",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6681 80.5213C52.6409 80.3042 49.5936 80.4439 49.0285 80.4439C48.3984 80.4439 48.1461 80.486 48.039 81.1409C47.9267 81.8268 47.7071 82.3841 47.1699 82.8445",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7485 58.6061C64.9236 58.6061 65.0853 58.5624 65.2476 58.4943C66.0471 58.159 66.761 57.7143 67.5923 57.4403C68.5653 57.1195 69.5222 56.9508 70.5478 56.9197C71.189 56.9003 71.532 56.9782 71.9116 57.4747C72.1618 57.8018 72.4757 58.0147 72.8194 58.2362C73.2745 58.5295 73.4496 58.9578 73.7314 59.3805",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2236 58.6836C54.3918 58.2875 53.7379 57.6516 53.0554 57.0402C51.9235 56.0262 50.9912 54.8261 50.1643 53.5554C49.9614 53.2436 49.5317 52.7988 49.6523 52.3766C49.6863 52.2577 49.9071 52.176 49.9578 52.0238",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1565 61.6263C44.629 61.2746 43.4992 62.2827 43.1431 62.5727C42.2656 63.2873 41.4039 64.1919 40.6908 65.068C40.1791 65.6967 39.8906 66.1777 39.8906 66.9696",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0559 62.2458C29.9347 62.2609 29.7998 67.907 30.0559 68.6904C30.2717 69.3503 30.3583 70.0184 30.5206 70.6866C30.607 71.0428 30.8217 71.3493 30.9077 71.6933",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7193 78.2756C25.6759 77.8846 24.8017 77.3269 24.5061 77.114C23.9509 76.7143 23.3697 76.359 22.8197 75.9524C22.2377 75.5223 21.5318 75.4569 20.845 75.2942C20.2118 75.1443 19.6544 74.8909 19.0596 74.636",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.689 61.5868C16.689 60.5429 17.6258 59.7956 18.2746 59.0832C19.2689 57.9914 20.76 56.9621 21.3531 55.5782C21.5459 55.1281 22.7177 52.1667 22.5307 52.0732",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3867 51.0717C38.3867 49.5691 39.2577 48.6711 40.2598 47.5667C40.9752 46.7783 42.4366 45.8976 43.5608 45.8976",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6748 61.4199C5.68291 60.5182 4.77003 59.682 3.8374 58.7494C3.02254 57.9345 2.02318 57.2581 1 56.7465",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17691 49.5696C7.64218 49.4359 8.11419 46.0416 8.26036 45.7493C8.3942 45.4816 10.9453 44.3365 9.84597 44.0617",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.25 39.889C59.264 39.8049 59.6722 40.6011 59.76 40.7328C60.0258 41.1315 60.2451 41.5517 60.5852 41.8919C61.2777 42.5844 61.461 44.003 61.7536 44.8962C62.0057 45.6658 62.1645 46.4984 62.4583 47.2329C62.5814 47.5406 62.5881 48.4059 62.5881 48.4012",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8772 44.2286C32.7116 44.1243 29.7477 39.4731 29.4663 39.0638C28.923 38.2735 27.5745 38.3869 26.7031 38.3869",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8916 34.5481C45.0044 32.9917 48.239 31.8776 51.739 31.8776",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5952 34.8819C66.2807 33.5674 65.5923 31.5877 65.5923 29.7449C65.5923 28.1275 65.7012 25.3103 67.7621 27.3711",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7794 33.7135C79.7794 35.7565 80.1132 37.751 80.1132 39.8056C80.1132 40.5571 80.1481 41.318 80.1039 42.0681C80.0162 43.5606 79.1731 44.3444 78.1104 45.23",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0185 34.548C14.0185 32.7347 13.7017 30.9231 14.7603 29.3832C15.5751 28.1981 17.0553 28.2056 18.3581 28.2056",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5493 25.0344C35.5493 24.0023 35.9746 21.9716 35.3824 21.0658C34.6356 19.9236 32.915 19.3106 31.7104 18.8589",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3593 10.5136C19.3593 11.5151 19.3593 12.5165 19.3593 13.5179C19.3593 14.0597 19.1867 14.9157 19.5262 15.391C20.1029 16.1984 21.4659 16.2922 22.1967 17.023",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7222 12.1827C41.303 12.2659 43.0149 13.4364 44.5161 13.9259C45.2404 14.1621 46.206 14.3015 46.5653 15.0201",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2443 15.6877C55.2443 17.5609 55.1601 19.4551 55.2536 21.3254C55.2842 21.9371 55.6077 24.0133 56.5796 23.3654",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4368 24.7006C73.4368 23.1274 73.4368 21.5541 73.4368 19.9809C73.4368 19.4045 73.5761 19.0611 73.103 18.7569C72.1705 18.1574 71.3568 17.323 70.5994 16.5222C70.1952 16.0949 69.8375 15.545 69.2642 15.3539",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7705 9.01148C74.2696 8.56782 75.5511 8.18195 76.1999 7.93587C77.177 7.56523 80.3235 7.34242 79.2784 7.34242",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2471 5.33955C57.3196 4.68716 58.8731 4.20943 59.3241 3.91158C60.2719 3.28569 61.1642 2.61294 62.2172 2.16834C62.7464 1.94487 63.2697 1.44506 63.8306 1.34308C64.3146 1.25508 64.1451 1.15547 63.7564 1",
    stroke: "#D2CBC3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern1);
export default __webpack_public_path__ + "static/media/bg-pattern1.1bd005506962a25e6dba8be84f4ffbf4.svg";
export { ForwardRef as ReactComponent };